import { useMemo } from "react";

import { useOptimizelyContext } from "./context";

export const useExperiment = (experimentId: string) => {
  const { activeExperiments, experiments, variationMap } = useOptimizelyContext();

  const experiment = useMemo(() => experiments?.[experimentId], [experimentId, experiments]);

  const isExperimentActive = useMemo(
    () => activeExperiments?.includes(experimentId) ?? false,
    [activeExperiments, experimentId],
  );

  const variant = useMemo(() => {
    if (!isExperimentActive) return;
    return variationMap?.[experimentId];
  }, [experimentId, isExperimentActive, variationMap]);

  return {
    experiment,
    isExperimentActive,
    variant,
  };
};
